export default __webpack_public_path__ + "static/media/wvoit.570f0678.png";